import { render, staticRenderFns } from "./ConfirmaDadosInscritoEleitoral.vue?vue&type=template&id=40792a49&scoped=true"
import script from "./ConfirmaDadosInscritoEleitoral.vue?vue&type=script&lang=js"
export * from "./ConfirmaDadosInscritoEleitoral.vue?vue&type=script&lang=js"
import style0 from "./ConfirmaDadosInscritoEleitoral.vue?vue&type=style&index=0&id=40792a49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40792a49",
  null
  
)

export default component.exports